DealsSearchParamsHelper = require './helpers/search_params'
DealsGTMHelper = require './helpers/gtm-update'
BrowseContentHelper = require '../../browse/frontend/helpers/content'
{updateSeoPageMetaHash} = require '../../seo/frontend/page_meta_updater'

class Page
  constructor: (pageNumber, data) ->
    paginationData = data.metadata.pagination

    _.extend this,
      clearanceDealsCount: data.clearanceDealsCount
      countHtml: paginationData.countHtml
      totalDealCount: paginationData.availableCount
      bloodhoundHtml: paginationData.bloodhoundHtml
      dealCount: paginationData.dealsCount
      dealIdList: data.metadata?.pagination?.dealIdList or []
      dealsHtml: data.dealsHtml
      featuredHtml: data.featuredHtml
      carouselHtml: data.carouselHtml
      topDealsHtml: data.topDealsHtml
      nextPageSize: paginationData.nextPageSize
      number: pageNumber
      totalPages: paginationData.totalPages
      facets: data.metadata.facets
      firstDeal: data.metadata.firstDeal
      startingIndex: paginationData.startingIndex
      endingIndex: paginationData.endingIndex
      refinementUiPageData: data.refinementUiPageData
      cardsHtml: data.cardsHtml
      seoMetaHash: data.seoMetaHash

performSearch = (params = {}) ->
  @xhr?.abort()

  @xhr = $.ajax
    url: '/goods/deals/partial'
    data: params

  search = _.clone Backbone.Events

  @xhr.done _(search.trigger).bind search, 'success'
  @xhr.fail (xhr, textStatus) =>
    search.trigger 'error' unless textStatus == "abort"

  @xhr.always ->
    search.trigger 'complete', arguments...
    search.off()

  { on: _(search.once).bind(search) }

module.exports = class DealsApplication
  constructor: (options={}) ->
    @_events = _.extend {}, Backbone.Events

    @params = DealsSearchParamsHelper.getBaseParams(options)

    @_searchedServerSide = false
    @_pageNumber = if isNaN(Number(@params.page)) then 1 else Number(@params.page)

    # Validate price param prior to ticking off deals partial search to server app
    delete @params.minPrice unless /^\d+$/.test @params.minPrice
    delete @params.maxPrice unless /^\d+$/.test @params.maxPrice
    if @params.minPrice? and @params.maxPrice? and parseInt(@params.minPrice,10) > parseInt(@params.maxPrice,10)
      delete @params.minPrice
      delete @params.maxPrice

    # pageData is passed in as a mock search result when the deals are rendered server-side
    if not options.pageData
      if options.pageNumber?
        _.extend @params, page: options.pageNumber
        @_pageNumber = options.pageNumber

      dealsSearch = performSearch(@params)
      dealsSearch.on 'error', @_triggerErrorHandler
      dealsSearch.on 'success', @_triggerSuccessHandler
    else
      @page = new Page(@_pageNumber, options.pageData)
      @_searchedServerSide = true

      null

  on: (event, callback) ->
    @_events.on event, callback

  unfilteredParams: ->
    unfilteredParams(@params)

  nextPage: ->
    new @constructor({
      @params
      pageNumber: @_pageNumber + 1
    })

  _triggerErrorHandler: =>
    @_events.trigger 'error'
    @_events.stopListening()

  _triggerSuccessHandler: ({deals}={}, textStatus) =>
    if textStatus != 'success'
      @_triggerErrorHandler()
    else
      @page = new Page(@_pageNumber, deals)

      Groupon.pagination = deals.metadata?.pagination

      @_events.trigger 'success', deals
      @_events.stopListening()

      if @params
        DealsGTMHelper.update @params

      if deals.adSenseAd
        pageOptions =
          pubId: deals.adSenseAd.pubId
          query: deals.adSenseAd.category
          textColorPalette: ['#333']
        adSenseBlock =
          container: 'adsense-container'
          width: deals.adSenseAd.width,
          height: deals.adSenseAd.height
          linkTarget: '_blank'
          adLoadedCallback: (container, adsLoaded) ->
            if adsLoaded then $("#adsense-container").css({"min-height":265}) else $("#adsense-container").css({"min-height":0, "height":0})
        if deals.adSenseAd.showAds
          _googCsa('plas', pageOptions, adSenseBlock)

      if Groupon.enabledFeatures?.isSEOMetadataEnabled and (seoMetaHash = @page.seoMetaHash)
        updateSeoPageMetaHash seoMetaHash

  isEmptySearch: ->
    @page?.totalDealCount == 0

  isSearchedServerSide: ->
    @_searchedServerSide
